import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {borderStyle, icon} from '#core/utils/style-utils.js';

import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';
import {
    generateErrorNotification,
    generateInfoNotification,
    generateWarningNotification,
} from '#core/application/modules/tiles/notification/index.js';
import {generateBetReceipt} from '#core/application/modules/tiles/bet-receipt/index.js';

// had to split it into separate files for better convenience
import {betslipBetsFactory} from './factory/betslip-bets.factory';
import {betslipFreeBetsFactory} from './factory/betslip-freebets.factory';
import {betslipSettingsFactory} from './factory/betslip-settings.factory';
import {betslipPlaceBetTotalInfoFactory} from './factory/betslip-place-bet-total-info.factory';
import {slidingBetslipButtonFactory} from './factory/sliding-betslip-button.factory';

export function betslipFactory(PALETTE) {
    return {
        BetslipView: {
            // it's a container for Betslip, BetReceipt:
            container: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_CONTAINER_BG),
                },
            },
            betReceipt: {
                placedBetReceiptView: generateBetReceipt({
                    ...PALETTE.BETSLIP_BET_RECEIPT,
                    BET_RECEIPT_CONTAINER_BG: PALETTE.BETSLIP_BET_RECEIPT_BG,
                }),
            },
        },
        Betslip: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_CONTAINER_BG),
                    padding: 0,
                    ...PALETTE.BETSLIP_CONTAINER_TEXT,
                },
            },
            innerContainer: {
                style: {
                    _mobile_padding: '24px 0 0 0',
                    ...resolveBackground(PALETTE.BETSLIP_CONTAINER_BG, 'mobile'),
                    overflow: 'unset',
                },
            },
            disabledOverlay: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_LOADING_OVERLAY_BG),
                    bottom: '0px',
                },
            },
            emptyBetslipText: {
                style: {
                    ...PALETTE.BETSLIP_EMPTY_CONTENT_MESSAGE.EMPTY_CONTENT_MESSAGE_TEXT,
                },
            },
            emptyBetslipTextContainer: {
                style: {
                    _mobile_padding: '24px 10px',
                    _mobile_height: 170,
                    _desktop_height: 80, // to fit settings popover
                    _desktop_maxWidth: 314,
                    textAlign: 'center',
                },
            },
            betslipSettingsContainer: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_SETTINGS_CONTAINER_BG),
                    ...borderStyle(0, PALETTE.BETSLIP_SEPARATOR_COLOR, '1px 0 1px 0'),
                },
            },
        },
        BetslipError: {
            errorText: {
                style: {
                    textAlign: 'left',
                    ...PALETTE.BETSLIP_ERROR_MESSAGE_TEXT,
                },
            },
            okButton: merge(generatePrimaryButton(PALETTE.BETSLIP_ERROR_OK_BUTTON), {
                style: {
                    base: {
                        height: '40px',
                    },
                },
            }),
        },
        BetslipNotifications: {
            error: generateErrorNotification(PALETTE.BETSLIP_ERROR_NOTIFICATION),
            warning: generateWarningNotification(PALETTE.BETSLIP_WARNING_NOTIFICATION),
            info: generateInfoNotification(PALETTE.BETSLIP_INFO_NOTIFICATION),
            depositButton: generateSecondaryButton(PALETTE.BETSLIP_NOTIFICATION_DEPOSIT_BUTTON),
        },
        SlidingBetslipController: {
            container: {
                style: {
                    _mobile_padding: 0,
                },
            },
            quickBetslip: {
                view: {
                    slidingPane: {
                        overlay: {
                            style: {
                                overlay: {
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
            },
            betslipModule: {
                view: {
                    betslip: {
                        container: {
                            style: {
                                padding: 0,
                            },
                        },
                    },
                    betReceipt: {
                        placedBetReceiptView: {
                            container: {
                                style: {
                                    padding: '32px 0 0',
                                },
                            },
                        },
                    },
                },
            },
        },
        SlidingBetslipView: {
            bottomSheet: {
                swiperIndicator: {
                    style: {
                        ...resolveBackground(PALETTE.SLIDING_BETSLIP_SWIPER_COLOR),
                    },
                },
                contentContainer: {
                    style: {
                        boxShadow: PALETTE.SLIDING_BETSLIP_CONTAINER_SHADOW,
                        padding: 0,
                        borderRadius: '8px 8px 0 0',
                        overflow: 'hidden',
                    },
                },
                shimPlaceholder: {
                    style: {
                        ...resolveBackground(PALETTE.SLIDING_BETSLIP_CONTAINER_BG),
                    },
                },
            },
        },
        ShareBetslip: {
            hide: !FEATURES.betSharing || QUANTUM_BASED,
            shareButton: {
                buttonIcon: icon(PALETTE.BETSLIP_SHARE_BUTTON.TERTIARY_BUTTON_ICON_COLOR),
            },
        },
        ...betslipBetsFactory(PALETTE),
        ...betslipFreeBetsFactory(PALETTE),
        ...betslipSettingsFactory(PALETTE),
        ...betslipPlaceBetTotalInfoFactory(PALETTE),
        ...slidingBetslipButtonFactory(PALETTE),
    };
}
